{
  "version": 1,
  "asset_id": "e5ef9f27-b588-4897-9ff5-0176d555b21c",
  "project_id": "1e4fe108-4756-4697-836a-97816893411c",
  "url": "/__l5e/assets-v1/e5ef9f27-b588-4897-9ff5-0176d555b21c/founders-trailer-final.mp4",
  "r2_key": "a/v1/1e4fe108-4756-4697-836a-97816893411c/e5ef9f27-b588-4897-9ff5-0176d555b21c/founders-trailer-final.mp4",
  "original_filename": "founders-trailer-final.mp4",
  "size": 17644325,
  "content_type": "video/mp4",
  "created_at": "2026-09-05T06:33:37Z"
}
